import {
  localLeaderboard,
  type LeaderboardKind,
  type LeaderboardProvider,
  type LeaderboardView,
} from '@/core/leaderboard';
import type { AccountService } from '@/account/AccountService';

/**
 * SupabaseLeaderboardProvider (M100) — the real WORLD RANKINGS board through
 * the M78 provider seam. Signed in: top-20 from the server (nicknames +
 * points + true ranks) with the player's own row guaranteed present (appended
 * with its server rank when outside the top 20). Signed out, or on any
 * network hiccup: the familiar local ladder — the screen never breaks.
 */
export class SupabaseLeaderboardProvider implements LeaderboardProvider {
  constructor(private readonly account: AccountService) {}

  async fetch(playerPoints: number, kind: LeaderboardKind): Promise<LeaderboardView> {
    const board = await this.account.fetchLeaderboard(kind);
    if (!board) return localLeaderboard(playerPoints, kind);
    const rows = board.rows.map((r) => ({
      id: r.id,
      name: r.name,
      points: r.points,
      isPlayer: r.isPlayer,
      rank: r.rank,
    }));
    if (!rows.some((r) => r.isPlayer)) {
      rows.push({
        id: 'me',
        name: 'You',
        points: board.playerPoints,
        isPlayer: true,
        rank: board.playerRank,
      });
    }
    return { rows, playerRank: board.playerRank };
  }
}
